export var subscribeToNewsletterMutation = "\n  mutation SubscribeToNewsletter ($email: String! $locale: Locale!) {\n    data: subscribeToNewsletter_v2 (email: $email, locale: $locale) {\n      visitorHash\n    }\n  }\n";
